/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';
import { OutOfStockUpdateInput } from '../../models/out-of-stock-update-input';

export interface OutOfStockBulk$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
      body: Array<OutOfStockUpdateInput>
}

export function outOfStockBulk(http: HttpClient, rootUrl: string, params: OutOfStockBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, outOfStockBulk.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

outOfStockBulk.PATH = '/stores/{storeId}/availability/out-of-stock/bulk';
